import {ITag} from "../../models/Tag";
import React, {useEffect, useState} from "react";
import {Button, Grid, TextField, Typography} from "@mui/material";
import {Add, Delete} from "@mui/icons-material";

interface ITagsCard{
	tags?: ITag[];
	
	onChangeTags(tags: ITag[] | undefined): void;
}

export const TagsCard: React.FC<ITagsCard> = (props) => {
	
	const [tags, setTags] = useState(props.tags);
	const [newTagKey, setNewTagKey] = useState("");
	const [newTagValue, setNewTagValue] = useState("");
	
	
	useEffect(() => {
		props.onChangeTags(tags);
	}, [tags]);
	
	const handleDeleteTag = (tagToDelete: ITag) => {
		setTags(tags?.filter(tag => tag !== tagToDelete));
	};
	
	
	const handleAddTag = () => {
		if (newTagKey && newTagValue) {
			setTags([...tags??[], {id: 0, key: newTagKey, value: newTagValue }]);
			setNewTagKey("");
			setNewTagValue("");
		}
	};
	
	const handleTagKeyChange = (index:number, value:string) => {
		if (!tags)
			return;
		const updatedTags = [...tags];
		
		updatedTags[index].key = value;
		setTags(updatedTags);
	};
	const handleTagValueChange = (index:number, value:string) => {
		if (!tags)
			return;
		const updatedTags = [...tags];
		
		updatedTags[index].value = value;
		setTags(updatedTags);
	};
	
	return (
		<>
			<Typography variant={"h5"}>Tags</Typography><br/>
			<Grid container spacing={2} alignItems="center">
				{tags?.map((tag, index) => (
					<Grid item key={index}>
						<TextField
							label="Key"
							value={tag.key}
							onChange={(e) => handleTagKeyChange(index, e.target.value)}
						/>
						<TextField
							label="Value"
							value={tag.value}
							onChange={(e) => handleTagValueChange(index, e.target.value)}
						/>
						<Button
							variant="contained"
							color="error"
							onClick={() => handleDeleteTag(tag)}
						>
							<Delete/>
						</Button>
					</Grid>
				))}
				<Grid item>
					<TextField
						label="Key"
						value={newTagKey}
						onChange={(e) => setNewTagKey(e.target.value)}
					/>
					<TextField
						label="Value"
						value={newTagValue}
						onChange={(e) => setNewTagValue(e.target.value)}
					/>
					<Button variant="contained" color="primary" onClick={handleAddTag}>
						<Add/>
					</Button>
				</Grid>
			</Grid>
		</>
	);
};
